<template>
	<div>
        <template v-if="isAgentAccount">
            <template v-if="latestComment != '' && (agent_company.check_status == 'revision' || agent_company.check_status == 'rejected')">
                <b-alert 
                    variant="warning" 
                    show
                >
                    <span v-html="latestComment"></span>
                </b-alert>
            </template>
            <template v-else>
                <b-alert 
                    v-if="!isFormComplete"
                    variant="warning" 
                    show
                >
                    ⚠️ Заполните данные агентской компании и загрузите все необходимые документы.
                </b-alert>
                <b-alert 
                    v-if="isFormComplete"
                    variant="success" 
                    show
                >
                    ✅ Форма выглядит хорошо заполненной! <br>Если всё ок, нажмите кнопку отправки на проверку. 
                </b-alert>
            </template>
        </template>

		<b-form @submit.prevent="submitProfile(false)">
			<b-row>
				<b-col cols="12" md="6">
					<b-form-group label="Название компании (или ФИО) *">
						<b-form-input v-model="form.full_name" required placeholder="Иванов Иван Иванович / ИП Иванов"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<b-form-group label="Тип *">
						<b-form-select v-model="form.type" :options="typeOptions" required></b-form-select>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<b-form-group label="ИНН *">
						<b-form-input v-model="form.inn" required placeholder="123456789012"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<b-form-group label="ОГРНИП (для ИП)">
						<b-form-input v-model="form.ogrnip" placeholder="304770000000000"></b-form-input>
					</b-form-group>
				</b-col>

                <b-col cols="12" md="6">
					<b-form-group label="Выберите ваш основной регион деятельности *">
						<b-form-select 
                            v-model="form.region_id" 
                            :options="regionOptions" 
                            required 
                            placeholder="Выберите регион"
                            first-option="Выберите регион"
                        ></b-form-select>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group label="Адрес регистрации *">
						<b-form-input v-model="form.registration_address" required placeholder="г. Москва, ул. Ленина, д. 10"></b-form-input>
					</b-form-group>
				</b-col>

                <b-col cols="12">
                    <b-form-group label="Фактический адрес *">
                        <b-form-input v-model="form.address" required placeholder="г. Москва, ул. Арбат, д. 5"></b-form-input>
                    </b-form-group>
                </b-col>

				<b-col cols="12" md="6">
					<b-form-group label="Расчётный счёт *">
						<b-form-input v-model="form.bank_account" required placeholder="40702810900000012345"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<b-form-group label="Название банка *">
						<b-form-input v-model="form.bank_name" required placeholder="АО 'Т-Банк'"></b-form-input>
					</b-form-group>
				</b-col>

				<!-- Комиссионные ставки для агента (только не агентский аккаунт) -->
				<template v-if="!isAgentAccount">
					<b-col cols="12" md="4">
						<b-form-group label="Процент за первую поставку (%)">
							<b-form-input v-model.number="form.first_order_commission_rate" type="number" step="0.01" min="0" max="100" placeholder="30.00"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col cols="12" md="4">
						<b-form-group label="Процент за поставки в первый год (%)">
							<b-form-input v-model.number="form.first_year_order_commission_rate" type="number" step="0.01" min="0" max="100" placeholder="25.00"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col cols="12" md="4">
						<b-form-group label="Процент за последующие поставки (%)">
							<b-form-input v-model.number="form.next_orders_commission_rate" type="number" step="0.01" min="0" max="100" placeholder="20.00"></b-form-input>
						</b-form-group>
					</b-col>
				</template>

				<b-col cols="12" md="6">
					<b-form-group label="БИК *">
						<b-form-input v-model="form.bik" required placeholder="044525974"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<b-form-group label="Корреспондентский счёт *">
						<b-form-input v-model="form.correspondent_account" required placeholder="30101810100000000974"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="4">
					<b-form-group label="Серия паспорта *">
						<b-form-input v-model="form.passport_series" required placeholder="4510"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="4">
					<b-form-group label="Номер паспорта *">
						<b-form-input v-model="form.passport_number" required placeholder="123456"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="4">
					<b-form-group label="Дата выдачи паспорта *">
						<b-form-input v-model="form.passport_issued_date" type="date" required></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group label="Кем выдан *">
						<b-form-input v-model="form.passport_issued_by" required placeholder="ОУФМС России по г. Москве"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<b-form-group label="Код подразделения *">
						<b-form-input v-model="form.passport_issued_code" required placeholder="770-001"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12" md="6">
					<b-form-group label="Дата рождения *">
						<b-form-input v-model="form.birth_date" type="date" required></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group label="СНИЛС">
						<b-form-input v-model="form.snils" placeholder="112-233-445 95"></b-form-input>
					</b-form-group>
				</b-col>

				<!-- Файлы -->
                <b-col cols="12" md="6" v-for="fileField in fileFields" :key="fileField.name">
                    <b-form-group :label="fileField.label">
                        <b-form-file 
                            v-model="files[fileField.name]" 
                            :required="!form[fileField.existingField] && fileField.required"
                            :disabled="!isAgentAccount"
                            browse-text="Выбрать файл"
                            placeholder="Файл не выбран"
                        ></b-form-file>
                
                        <!-- Статус файла -->
                        <div v-if="form[fileField.existingField]" class="mt-2 text-success">
                            <a :href="hfs + agent_company[fileField.name].path" target="_blank">✅ Файл загружен</a>
                        </div>
                        <div v-else-if="files[fileField.name]" class="mt-2 text-info">
                            📎 Файл выбран
                        </div>
                        <div v-else class="mt-2 text-secondary">
                            ⚠️ Файл не приложен
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>

			<!-- Согласие на обработку ПД (только для агентов) -->
			<template v-if="isAgentAccount">
				<b-form-group label="Для сохранения необходимо Ваше согласие с нашими условиями">
					<div class="d-flex align-items-start">
						<b-form-checkbox 
							v-model="agreeConfidential" 
							required
							class="mt-1 mr-2"
						></b-form-checkbox>
						<div class="flex-grow-1" style="padding-top: 4px; margin-left: -5px;">
							Я принимаю <a href="#" class="text-primary" @click.prevent.stop="openPrivacyModal">Политику обработки ПД</a>
						</div>
					</div>
				</b-form-group>

				<b-form-group label="Согласие на обработку персональных данных">
					<ConcentPersonalData 
						@consent-scrolled="onConsentScrolled"
						:rows="7"
						:userData="userDataForConsent"
					/>
				</b-form-group>
			</template>

			<div class="row align-items-center">
				<div class="col d-flex flex-row-reverse">
                    <template v-if="isAgentAccount">                    
                        <b-button
                            variant="success"
                            class="ml-2"
                            :title="isFormComplete && agreeConfidential && consentScrolled ? 'Если всё хорошо, нажмите чтобы отправить на проверку':'Станет доступно после заполнения всех обязательных полей и согласия на обработку ПД'"
                            :disabled="loading || sendingToLawyer || !isFormComplete || !agreeConfidential || !consentScrolled"
                            @click="sendToLawyer()"
                        >
                            <span class="d-none d-md-inline">{{ sendingToLawyer ? 'Отправка' : 'Отправить' }} на проверку &raquo;</span>
                            <span class="d-inline d-md-none">На проверку &raquo;</span>
                            
                            <i class="fas fa-spinner fa-spin ml-1" v-if="sendingToLawyer"></i>
                        </b-button>
                    </template>
                    <template v-else-if="isCanModerate">
                        <div class="d-flex flex-wrap justify-content-end" style="gap: 8px;">
                            <!-- Если статус termination_by_company или rejected_before_offer - показываем только кнопку "Вернуть в работу" -->
                            <template v-if="agent_company.check_status === 'termination_by_company' || agent_company.check_status === 'rejected_before_offer'">
                                <b-button
                                    variant="success"
                                    class="btn-with-uppercase ml-2"
                                    :disabled="loading || (statusLoading != '' && statusLoading !== 'fill')"
                                    @click="sendStatusChange('fill')"
                                >
                                    <template v-if="statusLoading === 'fill'">Сохраняю статус... <i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    <template v-else>Вернуть в работу &raquo;</template>
                                </b-button>
                            </template>
                            
                            <!-- Если статус termination_by_agent - показываем только кнопку подтверждения расторжения -->
                            <template v-else-if="agent_company.check_status === 'termination_by_agent'">
                                <b-button
                                    variant="success"
                                    class="btn-with-uppercase ml-2"
                                    :disabled="loading || (statusLoading != '' && statusLoading !== 'approved_by_company')"
                                    @click="sendStatusChange('approved_by_company')"
                                >
                                    <template v-if="statusLoading === 'approved_by_company'">Сохраняю статус... <i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    <template v-else>Вернуть в работу &raquo;</template>
                                </b-button>
                                <b-button
                                    variant="danger"
                                    class="btn-with-uppercase ml-2"
                                    :disabled="loading || (statusLoading != '' && statusLoading !== 'termination_by_company')"
                                    @click="sendStatusChange('termination_by_company')"
                                >
                                    <template v-if="statusLoading === 'termination_by_company'">Сохраняю статус... <i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    <template v-else>Подтвердить расторжение договора &raquo;</template>
                                </b-button>
                            </template>
                            
                            <!-- Во всех остальных случаях показываем все кнопки -->
                            <template v-else>
                                <b-button
                                    variant="danger"
                                    class="btn-with-uppercase ml-2"
                                    :disabled="agent_company.check_status == 'rejected' || loading || (statusLoading != '' && statusLoading !== 'rejected')"
                                    @click="sendStatusChange('rejected')"
                                >
                                    <template v-if="statusLoading === 'rejected'">Сохраняю статус... <i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    <template v-else>Отказать &raquo;</template>
                                </b-button>
                                
                                <b-button
                                    variant="warning"
                                    class="btn-with-uppercase ml-2"
                                    :disabled="agent_company.check_status == 'revision' || loading || (statusLoading != '' && statusLoading !== 'revision')"
                                    @click="sendStatusChange('revision')"
                                >
                                    <template v-if="statusLoading === 'revision'">Сохраняю статус... <i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    <template v-else>На доработку &raquo;</template>
                                </b-button>
                                
                                <b-button
                                    variant="success"
                                    class="btn-with-uppercase ml-2"
                                    :disabled="agent_company.check_status == 'approved_by_company' || loading || (statusLoading != '' && statusLoading !== 'approved_by_company')"
                                    @click="sendStatusChange('approved_by_company')"
                                >
                                    <template v-if="statusLoading === 'approved_by_company'">Сохраняю статус... <i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    <template v-else>Проверен &raquo;</template>
                                </b-button>
                                
                                <b-button
                                    variant="outline-danger"
                                    class="btn-with-uppercase ml-2"
                                    :disabled="agent_company.check_status == 'rejected_before_offer' || loading || (statusLoading != '' && statusLoading !== 'rejected_before_offer')"
                                    @click="sendStatusChange('rejected_before_offer')"
                                >
                                    <template v-if="statusLoading === 'rejected_before_offer'">Сохраняю статус... <i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    <template v-else>Отказался до оферты &raquo;</template>
                                </b-button>
                                
                                <b-button
                                    variant="secondary"
                                    class="btn-with-uppercase ml-2"
                                    :disabled="agent_company.check_status == 'termination_by_company' || loading || (statusLoading != '' && statusLoading !== 'termination_by_company')"
                                    @click="sendStatusChange('termination_by_company')"
                                >
                                    <template v-if="statusLoading === 'termination_by_company'">Сохраняю статус... <i class="fas fa-spinner fa-spin ml-1"></i></template>
                                    <template v-else>Расторгнуть договор &raquo;</template>
                                </b-button>
                            </template>
                        </div>
                    </template>

					<b-button 
                        v-if="!hideSaveButton"
                        type="submit" 
                        variant="primary" 
                        :disabled="loading || sendingToLawyer || (isAgentAccount && (!agreeConfidential || !consentScrolled))"
                        class="ml-2"
                    >
						{{ loading ? 'Сохранение...' : 'Сохранить' }}
						<i class="fas fa-spinner fa-spin ml-1" v-if="loading"></i>
					</b-button>
					<b-button 
                        :disabled="loading || sendingToLawyer"
                        variant="secondary ml-2"
                        @click="close"
                    >Закрыть</b-button>
					<!-- <b-button variant="success" class="mr-2" @click="fillTestData">Тест</b-button> -->
				</div>
			</div>
		</b-form>

		<!-- Модальное окно политики конфиденциальности -->
		<PrivacyPolicyModal
			:visible.sync="showPrivacyModal"
		/>
	</div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { API_AGENT_COMPANY, HOST_FOR_STORAGE, API_REGIONS } from "@/constants";
    import ConcentPersonalData from "@components/agent/ConcentPersonalData.vue";
    import PrivacyPolicyModal from "@components/agent/PrivacyPolicyModal.vue";

    export default {
        components: {
            ConcentPersonalData,
            PrivacyPolicyModal
        },
        props: {
            agent_company: { type: Object, required: true },
            hideSaveButton: { type: Boolean, default: false }
        },
        data() {
            return {
                hfs: HOST_FOR_STORAGE,
                form: {
                    full_name: '',
                    type: '',
                    inn: '',
                    ogrnip: '',
                    registration_address: '',
                    address: '',
                    region_id: '',
                    bank_account: '',
                    bank_name: '',
                    first_order_commission_rate: 30,
                    first_year_order_commission_rate: 25,
                    next_orders_commission_rate: 20,
                    bik: '',
                    correspondent_account: '',
                    passport_series: '',
                    passport_number: '',
                    passport_issued_by: '',
                    passport_issued_code: '',
                    passport_issued_date: '',
                    birth_date: '',
                    snils: '',
                    ogrnip_file_id: null,
                    inn_file_id: null,
                    passport_main_file_id: null,
                    passport_registration_file_id: null,
                    bank_file_id: null,
                    snils_file_id: null
                },
                files: {
                    ogrnip_file: null,
                    inn_file: null,
                    passport_main_file: null,
                    passport_registration_file: null,
                    bank_file: null,
                    snils_file: null
                },
                typeOptions: [
                    { value: 'ip', text: 'Индивидуальный предприниматель' },
                    { value: 'fiz', text: 'Физическое лицо' }
                ],
                regionOptions: [
                    { value: '', text: 'Выберите регион' }
                ],
                regions: [],
                fileFields: [
                    { name: 'ogrnip_file', label: 'Файл ОГРНИП (только для ИП)', required: false, existingField: 'ogrnip_file_id' },
                    { name: 'inn_file', label: 'Файл ИНН *', required: true, existingField: 'inn_file_id' },
                    { name: 'passport_main_file', label: 'Основной разворот паспорта *', required: true, existingField: 'passport_main_file_id' },
                    { name: 'passport_registration_file', label: 'Страница с пропиской *', required: true, existingField: 'passport_registration_file_id' },
                    { name: 'bank_file', label: 'Файл реквизитов счета из банк-клиента *', required: true, existingField: 'bank_file_id' },
                    { name: 'snils_file', label: 'Файл СНИЛС', required: false, existingField: 'snils_file_id' }
                ],
                loading: false,
                sendingToLawyer: false,
                statusLoading: '',
                consentScrolled: false,
                agreeConfidential: false,
                showPrivacyModal: false
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),

            isAgentAccount() {
                return this.currentUser.role.includes('agent');
            },

            isCanModerate() {
                return this.currentUser.role.includes('administrator') 
                       || this.currentUser.role.includes('president') 
                       || this.currentUser.role.includes('lawyer-manager')
                       || this.currentUser.role.includes('lawyer-head-manager')
                       || this.currentUser.role.includes('hr-manager')
                       || this.currentUser.role.includes('hr-head-manager');
            },
            
            latestComment() {
                return this.getLatestComment();
            },

            isFormComplete() {
                const requiredFields = [
                    'full_name',
                    'type',
                    'inn',
                    'region_id',
                    'registration_address',
                    'address',
                    'bank_account',
                    'bank_name',
                    'bik',
                    'correspondent_account',
                    'passport_series',
                    'passport_number',
                    'passport_issued_by',
                    'passport_issued_code',
                    'passport_issued_date',
                    'birth_date'
                ];

                // Проверяем каждое обязательное текстовое поле
                for (const field of requiredFields) {
                    if (!this.form[field] || this.form[field].toString().trim() === '') {
                        return false;
                    }
                }

                // Проверяем файлы: либо новый загружен, либо есть file_id
                for (const fileField of this.fileFields) {
                    if (fileField.required) {
                        const fileUploaded = !!this.files[fileField.name];
                        const fileExists = !!this.form[fileField.existingField];
                        if (!fileUploaded && !fileExists) {
                            return false;
                        }
                    }
                }

                return true;
            },

            userDataForConsent() {
                // Объединяем данные: ФИО из currentUser, остальное из form
                return {
                    // ФИО из текущего пользователя
                    last_name: this.currentUser.last_name || '',
                    first_name: this.currentUser.first_name || '',
                    middle_name: this.currentUser.middle_name || '',
                    
                    // Остальные данные из формы агентской компании
                    registration_address: this.form.registration_address || '',
                    actual_address: this.form.address || '',
                    passport_series: this.form.passport_series || '',
                    passport_number: this.form.passport_number || '',
                    passport_issue_date: this.form.passport_issued_date || '',
                    passport_issued_by: this.form.passport_issued_by || '',
                    passport_department_code: this.form.passport_issued_code || '',
                    snils: this.form.snils || '',
                    inn: this.form.inn || '',
                    birth_date: this.form.birth_date || '',
                    birth_place: '',
                    citizenship: 'гражданин РФ',
                    gender: '',
                    phone: this.currentUser.phone || '',
                    email: this.currentUser.email || ''
                };
            }
        },
        async mounted() {
            await this.loadRegions();
        },
        watch: {
            agent_company: {
                immediate: true,
                handler(val) {
                    if (val) {
                        Object.keys(this.form).forEach(key => {
                            // Автозаполнение, если ключ есть
                            this.form[key] = val[key] || '';
                        });
                        // Приводим даты в формат input date
                        if (val.passport_issued_date) {
                            this.form.passport_issued_date = this.formatDate(val.passport_issued_date);
                        }
                        if (val.birth_date) {
                            this.form.birth_date = this.formatDate(val.birth_date);
                        }
                    }
                }
            }         
        },
        methods: {
            async loadRegions() {
                try {
                    const response = await api.call('get', API_REGIONS);
                    this.regions = response.data.data || response.data;
                    
                                         // Обновляем опции для селекта с нулевым элементом
                     this.regionOptions = [
                         { value: '', text: 'Выберите регион' },
                         ...this.regions.map(region => ({
                             value: region.id,
                             text: region.fullname,
                             disabled: false
                         }))
                     ];
                } catch (error) {
                    console.error('Ошибка загрузки регионов:', error);
                    this.$bvToast.toast('Ошибка загрузки списка регионов', { variant: 'danger', title: 'Ошибка' });
                }
            },
            async submitProfile(isInternalCall = false) {
                // Проверка согласия для агентов
                if (this.isAgentAccount && !isInternalCall) {
                    if (!this.agreeConfidential) {
                        this.$bvToast.toast('Необходимо принять политику обработки ПД', {
                            variant: 'danger',
                            title: 'Ошибка заполнения формы'
                        });
                        return false;
                    }

                    if (!this.consentScrolled) {
                        this.$bvToast.toast('Необходимо полностью прокрутить текст согласия на обработку ПД', {
                            variant: 'danger',
                            title: 'Ошибка заполнения формы'
                        });
                        return false;
                    }
                }

                this.loading = true;
                const formData = new FormData();
                formData.append('user_id', this.agent_company.user_id);

                for (const key in this.form) {
                    formData.append(key, this.form[key]);
                }

                // Добавляем данные о согласиях для агентов (только если согласия даны)
                if (this.isAgentAccount) {
                    if (this.agreeConfidential) {
                        formData.append('privacy_policy_accepted', 'true');
                    }
                    if (this.consentScrolled) {
                        formData.append('personal_data_consent_scrolled', 'true');
                    }
                }

                for (const key in this.files) {
                    if (this.files[key]) {
                        formData.append(`new_${key}`, this.files[key]);
                    }
                }

                try {
                    formData.append('_method', 'PUT');
                    await api.call('post', `${API_AGENT_COMPANY}/${this.agent_company.id}`, formData, {
                        headers: { "Content-Type": "multipart/form-data" }
                    });

                    if (!isInternalCall) {
                        this.$bvToast.toast('Профиль успешно сохранён.', { variant: 'success', title: 'Успех' });
                        this.$emit('updated', this.form);
                    }

                    return true;
                } catch (error) {
                    this.$bvToast.toast('Ошибка сохранения. Проверьте данные.', { variant: 'danger', title: 'Ошибка' });

                    return false;
                } finally {
                    this.loading = false;
                }
            },
            close() {
                this.$emit('closed');
            },
            async sendToLawyer() {
                this.sendingToLawyer = true;
                const success = await this.submitProfile(true); // Передаём флаг, что это "технический вызов"

                if (success) {
                    await this.sendStatusChange('pending');
                    this.$bvToast.toast('Отправлено на проверку нашим специалистам.', { variant: 'success', title: 'Отлично!' });
                } else {
                    this.sendingToLawyer = false;
                }
            },
            async sendStatusChange(newStatus) {
                if (!['fill', 'pending', 'approved', 'approved_by_company'].includes(newStatus)) {
                    // Запрос комментария
                    const { value: formValues } = await this.$swal.fire({
                        title: 'Оставьте комментарий',
                        html:
                            'Обязательно оставьте комментарий. Пользователь его увидит. <textarea id="statusChangeComment" class="swal2-textarea" placeholder="Введите причину..." style="min-height:100px"></textarea>',
                        focusConfirm: false,
                        showCancelButton: true,
                        cancelButtonText: 'Отмена',
                        confirmButtonText: 'Сохранить и сменить статус',
                        preConfirm: () => {
                            const comment = document.getElementById('statusChangeComment').value.trim();
                            if (!comment || comment.length < 3) {
                                this.$swal.showValidationMessage('Необходимо указать причину (минимум 3 символа)');
                                return false;
                            }
                            return { comment };
                        }
                    });

                    if (!formValues) return; // Нажали Отмена

                    // добавим комментарий
                    var commentText = formValues.comment;
                }

                this.statusLoading = newStatus;
                try {
                    await api.call('post', `${API_AGENT_COMPANY}/${this.agent_company.id}/change-status`, {
                        new_status: newStatus,
                        comment: commentText || null
                    });

                    this.form.check_status = newStatus;
                    this.$emit('updated', this.form);
                    this.$emit('closed');
                } catch (error) {
                    console.error('Ошибка смены статуса:', error);
                    this.$bvToast.toast('Не удалось сменить статус.', { variant: 'danger', title: 'Ошибка' });
                } finally {
                    this.sendingToLawyer = false;
                    this.statusLoading = '';
                }
            },
            formatDate(dateStr) {
                // Приводим "01.01.1990" -> "1990-01-01"
                if (!dateStr) return '';
                const parts = dateStr.split('.');
                if (parts.length === 3) {
                    return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
                }
                return dateStr;
            }, 
            getLatestComment() {
                try {
                    const latest = this.agent_company && this.agent_company.latest_status_with_comments;
                    const comments = latest && latest.user_comments;
                    if (comments && Array.isArray(comments) && comments.length > 0) {
                        let comment = `<div>⚠️ ${comments[0].comment}</div>
                                       <div class=\"text-right\"><small style=\"font-size: 12px;\">Дата сообщения: ${comments[0].created_at}</small></div>`;
                        return comment;
                    }
                } catch (e) {
                    console.error("Ошибка при парсинге this.agent_company.latest_status_with_comments в AgentCompanyProfile:", e);
                }

                return ''; 
            },
            fillTestData() {
                this.form = {
                    full_name: 'ИП Тестов Тест Тестович',
                    type: 'ip',
                    inn: '123456789012',
                    ogrnip: '304770000000000',
                    registration_address: 'г. Москва, ул. Ленина, д. 10',
                    address: 'г. Москва, ул. Арбат, д. 5',
                    region_id: '', 
                    bank_account: '40702810900000012345',
                    bank_name: 'АО "Тест Банк"',
                    bik: '044525974',
                    correspondent_account: '30101810100000000974',
                    passport_series: '4510',
                    passport_number: '123456',
                    passport_issued_by: 'УФМС России по г. Москве',
                    passport_issued_code: '770-001',
                    passport_issued_date: '2015-06-15',
                    birth_date: '1990-01-01',
                    snils: '112-233-445 95'
                };
            },
            
            openPrivacyModal() {
                this.showPrivacyModal = true;
            },
            
            onConsentScrolled(scrolled) {
                this.consentScrolled = scrolled;
            }
        }
    }
</script>

<style scoped>
.text-warning {
    color: #ffc107;
}

.mr-1 {
    margin-right: 0.25rem;
}

/* Мобильная адаптация формы */
@media (max-width: 768px) {
    /* Уменьшаем отступы между полями */
    .form-group {
        margin-bottom: 1rem;
    }
    
    /* Адаптируем лейблы */
    .form-group label {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 0.5rem;
        color: #495057;
    }
    
    /* Адаптируем поля ввода */
    .form-control {
        font-size: 16px; /* Предотвращает зум на iOS */
        padding: 0.75rem;
        border-radius: 0.375rem;
    }
    
    /* Адаптируем селекты */
    .custom-select {
        font-size: 16px;
        padding: 0.75rem;
        height: auto;
    }
    
    /* Адаптируем файловые поля */
    .custom-file-label {
        font-size: 14px;
        padding: 0.75rem;
    }
    
    /* Адаптируем чекбоксы */
    .form-check {
        margin-bottom: 1rem;
    }
    
    .form-check-input {
        margin-top: 0.25rem;
    }
    
    .form-check-label {
        font-size: 14px;
        line-height: 1.4;
    }
    
    /* Адаптируем кнопки */
    .btn {
        font-size: 14px;
        padding: 0.5rem 1rem;
        margin-bottom: 0.5rem;
        width: 100%;
    }
    
    /* Делаем кнопки компактными на мобильных */
    .btn-sm {
        font-size: 14px;
        padding: 0.375rem 0.75rem;
    }
    
    /* Применяем размер sm ко всем кнопкам на мобильных */
    .btn {
        font-size: 14px !important;
        padding: 0.375rem 0.75rem !important;
        line-height: 1.5;
    }
    
    /* Специальные стили для кнопок в ряду */
    .row .col .d-flex {
        flex-direction: column !important;
    }
    
    .row .col .d-flex .btn {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    
    /* Адаптируем алерты */
    .alert {
        font-size: 14px;
        padding: 1rem;
        margin-bottom: 1rem;
    }
    
    /* Адаптируем ссылки в алертах */
    .alert a {
        font-size: 14px;
    }
}

/* Дополнительная адаптация для очень маленьких экранов */
@media (max-width: 480px) {
    .form-group {
        margin-bottom: 0.75rem;
    }
    
    .form-group label {
        font-size: 13px;
    }
    
    .form-control {
        font-size: 16px;
        padding: 0.625rem;
    }
    
    .custom-select {
        font-size: 16px;
        padding: 0.625rem;
    }
    
    .btn {
        font-size: 15px;
        padding: 0.625rem 1.25rem;
    }
    
    .alert {
        font-size: 13px;
        padding: 0.875rem;
    }
}

/* Стили для согласия на обработку ПД */
@media (max-width: 768px) {
    /* Убираем правило для согласия на обработку ПД - оставляем в одну строку */
    .d-flex.align-items-start .form-check {
        margin-bottom: 0.5rem;
    }
    
    .d-flex.align-items-start .flex-grow-1 {
        margin-left: 0 !important;
        padding-top: 0 !important;
    }
}
</style>